export const FLEX_FIELDS_SLICE = 'FLEX_FIELDS_SLICE';
export const FLEX_FIELDS_API_PREFIX = 'dff';
